import { Beneficio, ModalidadeRecebimento, ResumoValores } from '../../core/models/requerimento';
import { formatarAliquota, formatarValor } from './formatadores';

/** Dado ainda não informado no requerimento. */
const SEM_VALOR = '-';

const NOME_DA_MODALIDADE: Record<ModalidadeRecebimento, string> = {
  S: 'Percentual de Saldo',
  P: 'Prazo Certo',
  F: 'Valor Fixo Mensal',
};

/** Bloco "Antecipação do benefício": bruto, IR (pela alíquota informada) e líquido. */
export interface AntecipacaoResumo {
  percentual: number;
  valorBruto: number;
  valorImpostoRenda: number;
  valorLiquido: number;
}

function arredondar(valor: number): number {
  return Math.round(valor * 100) / 100;
}

/** Modalidade da etapa 2 com o seu valor, ex.: "Prazo Certo (5 anos)". */
export function formaDeRecebimento(beneficio: Beneficio | null | undefined): string {
  if (!beneficio?.modalidade) return SEM_VALOR;

  const nome = NOME_DA_MODALIDADE[beneficio.modalidade];
  const detalhe = {
    S: beneficio.percentualSaldoMensal == null ? null : `${formatarAliquota(beneficio.percentualSaldoMensal)}%`,
    P: beneficio.qtdAnosPrazo == null ? null : `${beneficio.qtdAnosPrazo} ${beneficio.qtdAnosPrazo === 1 ? 'ano' : 'anos'}`,
    F: beneficio.valorFixoMensal == null ? null : `R$ ${formatarValor(beneficio.valorFixoMensal)}`,
  }[beneficio.modalidade];
  return detalhe ? `${nome} (${detalhe})` : nome;
}

/** IR e líquido sobre o bruto da antecipação. Sem antecipação (0% ou nulo), não há bloco. */
function antecipacao(
  percentual: number | null | undefined,
  valorBruto: number,
  aliquotaIr: number,
): AntecipacaoResumo | null {
  if (percentual == null || !(percentual > 0)) return null;

  const valorImpostoRenda = arredondar((valorBruto * aliquotaIr) / 100);
  return { percentual, valorBruto, valorImpostoRenda, valorLiquido: arredondar(valorBruto - valorImpostoRenda) };
}

/** Bruto da antecipação: o percentual da etapa 2 sobre o saldo geral. */
export function valorBrutoAntecipacao(percentual: number, saldoGeral: number): number {
  return arredondar((saldoGeral * percentual) / 100);
}

/** Resumo e detalhes: a partir do snapshot da etapa 6. */
export function calcularAntecipacao(valores: ResumoValores | null, aliquotaIr: number): AntecipacaoResumo | null {
  return valores ? antecipacao(valores.percentualAntecipacao, valores.valorAntecipacao, aliquotaIr) : null;
}

/** Etapa 3: a partir do percentual escolhido na etapa 2, antes de existir o snapshot. */
export function simularAntecipacao(
  percentual: number | null | undefined,
  saldoGeral: number,
  aliquotaIr: number,
): AntecipacaoResumo | null {
  return percentual == null ? null : antecipacao(percentual, valorBrutoAntecipacao(percentual, saldoGeral), aliquotaIr);
}
